import React, {Component} from 'react';
import {StyleSheet, View, Text, Platform, Alert} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import PropTypes from 'prop-types';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import {AppToast} from '../../HelperClasses/AppToast';
import Switch from 'react-switch';
import LocaleContext from '../../Localization/LocaleContext';
import {readCheckoutSettingsDraft, writeCheckoutSettingsDraft, clearCheckoutSettingsDraft} from './checkoutSettingsDrafts';

const AppConstants = require('../../Constants/AppConstants');

const APPURL = require('../../Constants/URLConstants');
class CartSetting extends Component {
  static contextType = LocaleContext;
  t = (key, fallback) => this.context?.translate?.(key, fallback) || fallback || key;
  constructor(props) {
    super(props);
    this.state = {
      subMenuSelectedIndex: 0,
      emailId: '',
      regexp: /^[0-9\.]+$/,
      minimumOrder: '',
      maximumQuantity: '',
      statusValue: Boolean(readCheckoutSettingsDraft('cart').statusValue),
      dataLoad: false,
      enableCoupon: Boolean(readCheckoutSettingsDraft('cart').enableCoupon),
    };
  }
  static propTypes = {
    backBtn: PropTypes.func,
    compact: PropTypes.bool,
  };
  componentDidUpdate() { if (this.draftReady && !this.draftCleared) writeCheckoutSettingsDraft('cart', {statusValue: this.state.statusValue, enableCoupon: this.state.enableCoupon}); }
  componentDidMount() {
    this.loadConfigApi();
  }
  //MARK:-  APIs Method 
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + '?key_group=orders',
      'get',
      '',
      '',
    );
    this.setState({currencyArray: []});
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      const draft = readCheckoutSettingsDraft('cart');
      this.setState({
        statusValue: draft.statusValue ?? configs['hide_quantity_select_in_cart'] ?? false,
        enableCoupon: draft.enableCoupon ?? configs['enable_coupon'] ?? false,
      });
    } else {
      this.setState(readCheckoutSettingsDraft('cart'));
    }
    this.draftReady = true;
    this.setState({dataLoad: true});
  };
  addOrUpdateCartApi = async () => {
    var configs = [];
    let fDict = {
      key_group: 'orders',
      key: 'hide_quantity_select_in_cart',
      value: this.state.statusValue,
      secured: false,
    };
    let fDict2 = {
      key_group: 'orders',
      key: 'enable_coupon',
      value: this.state.enableCoupon,
      secured: false,
    };
    configs.push(fDict);
    configs.push(fDict2);
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config,
      'post',
      JSON.stringify({configs: configs}),
    );
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      this.draftCleared = true;
      clearCheckoutSettingsDraft('cart');
      AppToast();
    }
  };
  //MARK:-  Buttons Action Method 
  saveBtnAction() {
    this.setState({dataLoad: false});
    return this.addOrUpdateCartApi();
  }
  onHandleTextChange = (text, id) => {
    let value = text;
    if (text == '' || this.state.regexp.test(value)) {
      if (id == 1) {
        this.setState({minimumOrder: text});
      } else {
        this.setState({maximumQuantity: text});
      }
    }
  };
  //MARK:-  UI 
  render() {
    return (
      <View
        style={
          this.props.compact
            ? styles.compactContainer
            : {width: '70%', marginBottom: 130, marginLeft: 10}
        }>
        {!this.props.compact && <Text style={tableStyle.listTitleText}>{this.t('checkout_settings.cart', 'Cart')}</Text>}
        {!this.props.compact && (
          <Text style={appConfigStyle.subTitleStyle}>
            {AppConstants.plainTextString}
          </Text>
        )}
        {!this.props.compact && (
          <View style={appConfigStyle.horizontalLineViewStyle} />
        )}
        <View
          style={[
            appConfigStyle.subViewStyle,
            this.props.compact && styles.compactSubView,
          ]}>
          <View style={{flexDirection: 'column', flex: 1.5}}>
            {/* <View style={{marginTop: -20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                Minimum Order value
              </Text>
              <TextInput
                style={appConfigStyle.txtFieldStyle}
                placeholder="Enter Minimum Order value "
                placeholderTextColor={colors.placeholderColor}
                onChangeText={text => this.onHandleTextChange(text, 1)}
                value={this.state.minimumOrder}
              />
            </View>
            <View style={{marginTop: 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                Maximum Cart Quantity
              </Text>
              <TextInput
                style={appConfigStyle.txtFieldStyle}
                placeholder="Enter Maximum Cart Quantity"
                placeholderTextColor={colors.placeholderColor}
                onChangeText={text => this.onHandleTextChange(text, 2)}
                value={this.state.maximumQuantity}
              />
            </View>
            <View style={{marginTop: 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>Cart Attributes</Text>
              <TextInput
                style={appConfigStyle.txtFieldStyle}
                placeholder="Enter Cart Attributes"
                placeholderTextColor={colors.placeholderColor}
              />
            </View> */}
            <View
              style={{
                flexDirection: 'row',
                flexWrap: 'wrap',
                marginTop: this.props.compact ? 14 : -20,
              }}>
              <Switch
                onColor={colors.AppNewGreen}
                onChange={() => {
                  this.draftCleared = false;
                  this.setState({statusValue: !this.state.statusValue})
                }}
                checked={this.state.statusValue}
                height={22}
                width={50}
              />
              <Text style={[appConfigStyle.statusTxtStyle, this.props.compact && styles.compactStatusText]}>
                {this.t('checkout_settings.hide_quantity_selection', 'Hide quantity selection (Default: Shows field to select quantity)')}
              </Text>
            </View>
            <View
              style={{
                flexDirection: 'row',
                flexWrap: 'wrap',
                marginTop: this.props.compact ? 14 : 20,
              }}>
              <Switch
                onColor={colors.AppNewGreen}
                onChange={() => {
                  this.draftCleared = false;
                  this.setState({enableCoupon: !this.state.enableCoupon})
                }}
                checked={this.state.enableCoupon}
                height={22}
                width={50}
              />
              <Text style={[appConfigStyle.statusTxtStyle, this.props.compact && styles.compactStatusText]}>
                {this.t('checkout_settings.enable_coupon', 'Enable Coupon')}
              </Text>
            </View>
          </View>
        </View>
        {!this.props.compact && <Appload enable={this.state.dataLoad} />}
      </View>
    );
  }
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: 'white',
  },
  compactContainer: {
    width: '100%',
    marginBottom: 10,
    marginLeft: 0,
  },
  compactSubView: {
    marginTop: 0,
    marginRight: 0,
    marginLeft: 0,
    marginBottom: 4,
    paddingTop: 4,
  },
  compactStatusText: {
    flex: 1,
    marginLeft: 12,
    lineHeight: 20,
  },
});

export default CartSetting;
